import { List, Map } from "immutable";

import { Dispatch, GetState } from "common/types";

import { getCourseProficiency } from "seneca-common/features/course/selectors/course";
import { getSectionProficiency } from "seneca-common/features/course/selectors/section";
import { reconcileSessionProficiencies } from "seneca-common/features/session/actions/stateActions";
import SessionReport from "seneca-common/features/session/models/SessionReport";
import {
  ContentStat,
  receiveAndResetContentStudyStats,
  transformServerContentStat
} from "seneca-common/features/stats/state";

import { reconcileContentStudyStats } from "./reconcileContentStudyStats";
import { reconcileCourseStudyStats } from "./reconcileCourseStudyStats";
import { reconcileSectionStudyStats } from "./reconcileSectionStudyStats";

export const reconcileContentSectionAndCourseStats = async (
  relevantSessionReports: List<SessionReport>,
  contentStatsFetch: Promise<Record<string, any>[]>,
  courseContentIds: List<string>,
  sectionStatsFetch: Promise<Record<string, any>>,
  courseStatsFetch: Promise<Record<string, any>>,
  dispatch: Dispatch,
  getState: GetState
) => {
  const contentStats = await contentStatsFetch;

  // Reset content stats to what is persisted on server - effectively rolling back to before the sessions were studied
  // @ts-ignore
  dispatch(receiveAndResetContentStudyStats(contentStats, courseContentIds));

  const transformedContentStats = transformContentStudyStats(contentStats);

  let startingProficiency,
    endingProficiencies = Map<string, number>(),
    startingCourseProficiency,
    endingCourseProficiencies = Map<string, number>();
  relevantSessionReports.forEach(report => {
    let state = getState();
    const sessionId = report.session!.sessionId;
    const sectionId = report.session!.sectionIds.first();
    const courseId = report.session!.courseId;
    startingProficiency = getSectionProficiency(state, sectionId!);
    startingCourseProficiency = getCourseProficiency(state, courseId!);

    reconcileContentStudyStats(
      report,
      transformedContentStats,
      courseContentIds,
      dispatch
    );

    state = getState();
    const endingProficiency = getSectionProficiency(state, sectionId!);
    const endingCourseProficiency = getCourseProficiency(state, courseId!);
    endingProficiencies = endingProficiencies.set(
      sectionId!,
      endingProficiency
    );
    endingCourseProficiencies = endingCourseProficiencies.set(
      courseId!,
      endingCourseProficiency
    );

    dispatch(
      reconcileSessionProficiencies(
        sessionId!,
        startingProficiency,
        endingProficiency,
        startingCourseProficiency,
        endingCourseProficiency
      )
    );
  });
  const sectionStats = await sectionStatsFetch;
  const courseStats = await courseStatsFetch;

  reconcileSectionStudyStats(
    relevantSessionReports,
    // @ts-ignore
    sectionStats,
    endingProficiencies,
    dispatch
  );
  reconcileCourseStudyStats(
    relevantSessionReports,
    courseStats,
    endingCourseProficiencies,
    dispatch
  );
};

const transformContentStudyStats = (
  contentStats: Record<string, any>[]
): List<ContentStat> => List(contentStats.map(transformServerContentStat));
